import type { ReactElement } from "react";
import { statusTone } from "./statusTone";
import styles from "./StatusBadge.module.css";

export function StatusBadge({ status }: { status: number }): ReactElement {
  return (
    <span className={`${styles.badge} ${styles[statusTone(status)]}`}>
      {status}
    </span>
  );
}
